import { NgModule } from '@angular/core';

import { SharedModule } from '../../shared';
import { MotivoPerdaVendaSituacaoModule } from './situacao';
import { MotivoPerdaVendaFormModule } from './form';

import { MotivoPerdaVendaRoutingModule } from './motivo-perda-venda-routing.module';
import { MotivoPerdaVendaComponent } from './motivo-perda-venda.component';

@NgModule({
    imports: [
        SharedModule,
        MotivoPerdaVendaRoutingModule,
        MotivoPerdaVendaFormModule,
        MotivoPerdaVendaSituacaoModule
    ],
    declarations: [
        MotivoPerdaVendaComponent
    ]
})
export class MotivoPerdaVendaModule { }
